import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabase';
import Header from '../components/Header';

const C = {
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  attivita: '#FF5B00',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e5e7eb',
  light: '#f5f7fa',
};

export default function Pacchetto() {
  const { slug } = useParams();
  const [esp, setEsp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copiato, setCopiato] = useState(false);

  useEffect(() => {
    const carica = async () => {
      const { data } = await supabase
        .from('esperienze')
        .select('*, profiles(username)')
        .eq('slug', slug)
        .single();
      setEsp(data || null);
      setLoading(false);
    };
    carica();
  }, [slug]);

  const handleCondividi = async () => {
    const url = window.location.href;
    if (navigator.share) {
      try { await navigator.share({ title: esp?.destinazione, url }); } catch (_) {}
    } else {
      await navigator.clipboard.writeText(url);
      setCopiato(true);
      setTimeout(() => setCopiato(false), 2000);
    }
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: C.light }}>
      <p style={{ color: C.textLight, fontFamily: 'Roboto, sans-serif' }}>Caricamento...</p>
    </div>
  );

  if (!esp) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif' }}>
      <div style={{ textAlign: 'center' }}>
        <p style={{ color: C.text, fontSize: '18px', marginBottom: '16px' }}>Esperienza non trovata</p>
        <a href="/bacheca" style={{ color: C.alloggio, textDecoration: 'none', fontWeight: 700 }}>← Torna alla bacheca</a>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        button { cursor: pointer; font-family: 'Roboto', sans-serif; }
        button:hover { opacity: 0.85; }
        .octa-hamburger { display: none; }
        .pkt-grid { display: grid; grid-template-columns: 1fr 1fr; }
        .pkt-q-tr { border-right: 1px solid ${C.border}; border-bottom: 1px solid ${C.border}; }
        .pkt-q-al { border-bottom: 1px solid ${C.border}; }
        .pkt-q-sv { border-right: 1px solid ${C.border}; }
        .pkt-q-at { }
        @media (max-width: 1024px) {
          .octa-header-p { padding: 12px 24px !important; }
          .octa-footer-p { padding: 24px 32px !important; }
          .pkt-main { padding: 32px 24px 60px !important; }
        }
        @media (max-width: 768px) {
          .octa-hamburger { display: flex !important; align-items: center; }
          .octa-header-p { padding: 12px 16px !important; }
          .octa-nav-link { display: none !important; }
          .octa-footer-p { padding: 24px 16px !important; flex-direction: column !important; align-items: flex-start !important; }
          .pkt-main { padding: 24px 16px 60px !important; }
          .pkt-q-tr, .pkt-q-tl, .pkt-q-sv, .pkt-q-at { padding: 14px 10px !important; }
          .pkt-actions { flex-direction: column !important; align-items: stretch !important; }
          .pkt-actions a, .pkt-actions button { text-align: center !important; }
          .pkt-header-bar { padding: 24px 20px !important; }
          .pkt-dest { font-size: 28px !important; }
        }
        @media (max-width: 480px) {
          .pkt-grid { grid-template-columns: 1fr !important; }
          .pkt-mondo { display: none !important; }
          .pkt-q-tr { border-right: none !important; }
          .pkt-q-sv { border-right: none !important; border-bottom: 1px solid ${C.border} !important; }
        }
      `}</style>

      <Header bg={C.dark} />

      {/* MAIN */}
      <main className="pkt-main" style={{ maxWidth: '920px', margin: '0 auto', padding: '40px 20px 60px' }}>

        <a href="/bacheca" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: C.textLight, textDecoration: 'none', fontSize: '13px', marginBottom: '28px', fontWeight: 600 }}>
          ← Bacheca
        </a>

        {/* CARD PACCHETTO */}
        <div style={{ backgroundColor: C.white, borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 32px rgba(0,0,0,0.10)', border: `1px solid ${C.border}` }}>

          {/* HEADER BAR */}
          <div className="pkt-header-bar" style={{ backgroundColor: C.dark, padding: '28px 32px' }}>
            <h1 className="pkt-dest" style={{ fontSize: '38px', fontWeight: 900, color: C.white, letterSpacing: '0.05em', textTransform: 'uppercase', marginBottom: '10px', lineHeight: 1 }}>
              {esp.destinazione || '—'}
            </h1>
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
              {esp.durata_notti && (
                <span style={{ fontSize: '15px', color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}>
                  {esp.durata_notti} {esp.durata_notti === 1 ? 'notte' : 'notti'} &nbsp;·&nbsp; {esp.num_adulti || 1} adult{(esp.num_adulti || 1) === 1 ? 'o' : 'i'}
                </span>
              )}
              {esp.prezzo_totale && (
                <span style={{ fontSize: '16px', color: C.white, fontWeight: 800 }}>
                  € {Number(esp.prezzo_totale).toLocaleString('it-IT')} spesa indicativa
                </span>
              )}
            </div>
            {esp.titolo && (
              <p style={{ marginTop: '10px', fontSize: '13px', color: 'rgba(255,255,255,0.45)', fontStyle: 'italic' }}>{esp.titolo}</p>
            )}
          </div>

          {/* 2x2 GRID SEGMENTI */}
          <div className="pkt-grid" style={{ position: 'relative' }}>

            {/* LOGO MONDO — centro intersezione 4 quadranti */}
            <div className="pkt-mondo" style={{
              position: 'absolute', top: '50%', left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 10,
              backgroundColor: C.white,
              borderRadius: '50%',
              width: '56px', height: '56px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 2px 12px rgba(0,0,0,0.14)',
              border: `2px solid ${C.border}`,
            }}>
              <img src="/images/logo_mondo.svg" alt="OCTA" style={{ width: '36px', height: '36px', objectFit: 'contain' }} />
            </div>

            <div className="pkt-q-tr">
              <Quadrante
                colore={C.trasporto}
                label="TRASPORTO"
                img="/images/trasporto_icona.png"
                testo={esp.trasporto}
              />
            </div>
            <div className="pkt-q-al">
              <Quadrante
                colore={C.alloggio}
                label="ALLOGGIO"
                img="/images/alloggio_icona.png"
                testo={esp.alloggio}
              />
            </div>
            <div className="pkt-q-sv">
              <Quadrante
                colore={C.servizi}
                label="SERVIZI"
                img="/images/servizi_icona.png"
                testo={esp.servizi}
              />
            </div>
            <div className="pkt-q-at">
              <Quadrante
                colore={C.attivita}
                label="ATTIVITÀ"
                img="/images/attivita_icona.png"
                testo={esp.attivita}
              />
            </div>
          </div>

          {/* AZIONI */}
          <div className="pkt-actions" style={{ padding: '18px 28px', borderTop: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '13px', color: C.textLight, marginRight: 'auto' }}>
              di <strong style={{ color: C.text }}>{esp.profiles?.username || 'utente'}</strong>
              {esp.volte_copiata > 0 && (
                <span style={{ marginLeft: '8px', color: C.textLight }}>· {esp.volte_copiata} {esp.volte_copiata === 1 ? 'copia' : 'copie'}</span>
              )}
            </span>
            <a href="/crea" style={{
              padding: '10px 22px',
              borderRadius: '8px',
              backgroundColor: C.dark,
              color: C.white,
              fontSize: '13px',
              fontWeight: 800,
              textDecoration: 'none',
              display: 'inline-block',
              letterSpacing: '0.04em',
            }}>
              COPIA / MODIFICA
            </a>
            <button
              onClick={handleCondividi}
              style={{
                padding: '10px 22px',
                borderRadius: '8px',
                border: `2px solid ${C.dark}`,
                backgroundColor: C.white,
                color: C.dark,
                fontSize: '13px',
                fontWeight: 800,
                letterSpacing: '0.04em',
              }}
            >
              {copiato ? 'LINK COPIATO ✓' : 'CONDIVIDI'}
            </button>
          </div>

        </div>
      </main>

      {/* FOOTER */}
      <footer className="octa-footer-p" style={{ padding: '32px 40px', borderTop: `1px solid rgba(255,255,255,0.08)`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.dark, flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>
    </div>
  );
}

function Quadrante({ colore, label, img, testo }) {
  const righe = testo ? testo.split('\n').filter(r => r.trim()) : [];

  return (
    <div style={{ padding: '22px 24px', minHeight: '200px' }}>
      {/* LABEL */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
        <div style={{ width: '3px', height: '20px', borderRadius: '2px', backgroundColor: colore, flexShrink: 0 }} />
        <img src={img} alt={label} style={{ height: '22px', objectFit: 'contain' }} />
        <span style={{ fontSize: '11px', fontWeight: 900, color: colore, textTransform: 'uppercase', letterSpacing: '0.12em' }}>
          {label}
        </span>
      </div>

      {/* CONTENUTO */}
      {righe.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
          {righe.map((riga, i) => {
            const isPrimaria = riga.startsWith('–') || riga.startsWith('-') || riga.startsWith('•') || /^[A-Z]/.test(riga.trim());
            const testoRiga = riga.replace(/^[–\-•]\s*/, '').trim();
            return (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '9px' }}>
                <span style={{
                  width: '6px', height: '6px', borderRadius: '50%',
                  backgroundColor: isPrimaria ? colore : `${colore}55`,
                  flexShrink: 0, marginTop: '7px',
                }} />
                <span style={{ fontSize: '13px', color: C.text, lineHeight: 1.55 }}>{testoRiga}</span>
              </div>
            );
          })}
        </div>
      ) : (
        <p style={{ fontSize: '13px', color: C.textLight, fontStyle: 'italic' }}>Nessuna informazione disponibile</p>
      )}
    </div>
  );
}
